module.exports = __webpack_public_path__ + "assets/img/map.9f61b8c9.png";